import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

const ProductSettings = (props) => {
  const { serviceProductForm, serviceProductPayload } = props

  const {
    callbacks: { updateServiceProduct: updateFn },
  } = serviceProductPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateServiceProduct },
  } = pageContext

  const {
    entityState: {
      options: {
        locked,
        skip_quotes,
      },
      orderable,
    },
  } = serviceProductForm

  const updateServiceProductPayload = {
    callbacks: {
      action: updateFn,
    },
    toastText: 'Product Updated',
  }

  return (
    <DashboardModule title="Product Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => updateServiceProduct({
            ...updateServiceProductPayload,
            entityParams: { orderable: !orderable },
          })}
          toggleOnText="Yes"
          toggleOffText="No"
          toggleValue={orderable}
        >
          <ToggleListItem.Title>Product is Orderable</ToggleListItem.Title>
          <ToggleListItem.Description>
            This product can be ordered if assigned to an agency.
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => updateServiceProduct({
            ...updateServiceProductPayload,
            entityParams: toggleNestedValue(serviceProductForm, 'options.locked'),
          })}
          toggleOnText="Yes"
          toggleOffText="No"
          toggleValue={locked}
        >
          <ToggleListItem.Title>Product is Locked</ToggleListItem.Title>
          <ToggleListItem.Description>
            Product is hidden until a linked product is ordered.
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => updateServiceProduct({
            ...updateServiceProductPayload,
            entityParams: toggleNestedValue(serviceProductForm, 'options.skip_quotes'),
          })}
          toggleOnText="Yes"
          toggleOffText="No"
          toggleValue={skip_quotes}
        >
          <ToggleListItem.Title>Skip Quotes</ToggleListItem.Title>
          <ToggleListItem.Description>
            This product does not need to be quoted.
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

ProductSettings.propTypes = {
  serviceProductForm: PropTypes.object.isRequired,
  serviceProductPayload: PropTypes.object.isRequired,
}

export default ProductSettings
